import React from 'react';
import cn from 'classnames';

const CheckboxComponent = ({ label, checked, onChange, className, disabled, name }) => {
  // Create a unique ID based on the label if it's a string; otherwise, use a default ID
  const checkboxId =
    typeof label === 'string'
      ? `checkbox-${label.replace(/\s+/g, '-')}`
      : `checkbox-${Math.random()
          .toString(36)
          .substr(2, 9)}`;

  return (
    <div className={cn('form-check', className)}>
      <input
        type="checkbox"
        className="form-check-input"
        id={checkboxId}
        readOnly={!onChange}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        name={name}
      />
      <label className="form-check-label" htmlFor={checkboxId}>
        {label}
      </label>
    </div>
  );
};

export default CheckboxComponent;
